module.exports = __webpack_public_path__ + "static/media/check-mark.fbadb7b1.svg";